import script from "./SellerSubAccounts.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerSubAccounts.vue?vue&type=script&setup=true&lang=js"

import "./SellerSubAccounts.vue?vue&type=style&index=0&id=577926e7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577926e7"]])

export default __exports__